import { getScrollableParent } from './scroll';

function focusSelector() {
  return [
    'a[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    '*[tabindex]'
  ].join(',');
}

function focusFirstElement() {
  const content = document.body.querySelector('.js-review-content');
  const firstChild = content || document.body.querySelector(focusSelector());
  if (!firstChild) return;

  firstChild.focus();
  const scrollableParent = getScrollableParent(firstChild);
  if (scrollableParent) scrollableParent.scrollTop = 0;
}

function setFocusTrapping() {
  document.removeEventListener('keydown', focusTrapping);
  document.addEventListener('keydown', focusTrapping);
}

function focusTrapping(e) {
  const focusableContent = document.body.querySelectorAll(focusSelector());
  const firstFocusableElement = focusableContent[0];
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      e.preventDefault();
    }
  } else {
    if (document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  }
}

export { focusFirstElement, setFocusTrapping };
